module.exports = __webpack_public_path__ + "media/components/common/formParts/icons/Delete-f4c5d944c2cd788528cca3d38ddaa9c1.svg";